// vue
import Vue from 'vue';
import Router from 'vue-router';
// routes
import { routes } from '@/routes';
// stores
import store from '@/store/store';

Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
});

router.afterEach((to, from) => {
  /*
    We'll need to put this is our production app to watch
    if want panels/dialogs to have a specific route.
    We'll have to come up with a unique name for that panel/dialog.
    This will allow panels such as quote activity
    to be associated to a route and will allow them to close by hitting back
  */
  if (to.fullPath.indexOf('toggle-panel') !== -1) {
    store.dispatch('togglePanelV1', true);
  }

  if (from.fullPath.indexOf('toggle-panel') !== -1 && to.fullPath.indexOf('toggle-panel' === -1)) {
    store.dispatch('togglePanelV1', false);
  }
});

export default router;
